import BEER_BOMB_IMAGE_URL from './beer.png';
export { BEER_BOMB_IMAGE_URL };
export const BEER_BOMB_SPRITESHEET_DATA = {
    frames: {
        'beer.png': {
            frame: { x: 1, y: 1, w: 88, h: 96 },
            rotated: false,
            trimmed: false,
            spriteSourceSize: { x: 0, y: 0, w: 88, h: 96 },
            sourceSize: { w: 88, h: 96 },
            anchor: { x: 0.528409, y: 0.846753 }
        }
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.0',
        image: BEER_BOMB_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 90, h: 98 },
        scale: '0.25',
        smartupdate: '$TexturePacker:SmartUpdate:e7eb47a0a7d068ac5e3c4b0bb969a422:1e7888d2471667dbfa005117193f242c:460f40ea147468c0366a258627bd0207$'
    }
};
